var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTemplateGroupEdit(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 14.5h12",
    stroke: "#7D8085",
    strokeWidth: 1.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.756 3.055l.743-.743L12.688 4.5l-.743.743-2.19-2.19zm-.701.7L3.4 9.41l-.128 2.319 2.318-.13 5.653-5.653-2.19-2.19zm2.102-2.482a.93.93 0 00-1.316 0L2.48 8.633a.93.93 0 00-.271.607l-.172 3.09L2 13l.67-.037 3.09-.172a.93.93 0 00.606-.27l7.361-7.362a.93.93 0 000-1.316l-2.57-2.57z",
    fill: "#7D8085"
  })));
}
export default __webpack_public_path__ + "static/template-group-edit.229849ca.svg";
export { SvgTemplateGroupEdit as ReactComponent };